import { VariableType } from '../Field';
export class DomainBase {
    constructor(dataType) {
        this._dataType = dataType;
    }
    get dataType() {
        return this._dataType;
    }
}
export class DiscreteDomain extends DomainBase {
    constructor(dataType) {
        super(dataType);
        this._keys = new Set();
        this._values = new Array();
    }
    get type() {
        return VariableType.DISCRETE;
    }
    get keys() {
        return this._keys;
    }
    get values() {
        return this._values;
    }
    add(value) {
        let keyValue = value;
        if (keyValue !== null) {
            switch (this.dataType) {
                case 'DATE':
                case 'DATETIME':
                    keyValue = value.valueOf();
                    break;
            }
        }
        if (!this.keys.has(keyValue)) {
            this.keys.add(keyValue);
            this.values.push(value);
        }
    }
    /**
     * An in-place set domain merge
     * @param domain A set domain to merge into this one
     */
    merge(domain) {
        for (const value of domain.values) {
            this.add(value);
        }
    }
}
export class ContinuousDomain extends DomainBase {
    constructor(dataType) {
        super(dataType);
        this._min = null;
        this._max = null;
    }
    get type() {
        return VariableType.CONTINUOUS;
    }
    get min() {
        return this._min;
    }
    get max() {
        return this._max;
    }
    add(value) {
        if (value === null || value === undefined) {
            return;
        }
        if (this.min === null || value < this.min) {
            this._min = value;
        }
        if (this.max === null || value > this.max) {
            this._max = value;
        }
    }
    merge(domain) {
        this.add(domain.min);
        this.add(domain.max);
    }
}
